"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetAcceptedGiftsCountQuery = void 0;

var _EmptyAppApi = require("../EmptyAppApi");

var dashboard = _EmptyAppApi.emptyAppApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getAcceptedGiftsCount: build.query({
        query: function query() {
          return '/enterprise/dashboard/accepted-gifts-count';
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        }
      })
    };
  }
});

var useGetAcceptedGiftsCountQuery = dashboard.useGetAcceptedGiftsCountQuery;
exports.useGetAcceptedGiftsCountQuery = useGetAcceptedGiftsCountQuery;